import {useGeoSearch} from "react-instantsearch";
import type {GeoHit} from "instantsearch.js";
import {type Practice} from "./PracticesMapContainer.tsx";
import {useMap} from "@vis.gl/react-google-maps";
import {actions, useApp} from "../providers/AppProvider.tsx";
import {useCallback} from "react";
import clsx from "clsx";
import {useSortedPractices} from "../hooks/useSortedPractices.tsx";
import PracticeCard from "./PracticeCard.tsx";

const PracticesList = () => {

    const {dispatch, state} = useApp();

    const {
        items
    } = useGeoSearch<GeoHit<Practice>>();

    const map = useMap();

    const sortedPractices = useSortedPractices(items);


    const selectPractice = useCallback((practice: Practice) => {
        dispatch(actions.setSelectedPractice(practice))
        setTimeout(() => {
            map?.setValues({autoPan: true})
            map?.setCenter(practice._geoloc)
            map?.panBy(-150, 0)
        }, 400)
    }, [dispatch, map])


    return (
        <div className={clsx(
            "practicesList py-8 gap-8 grid ",
            {' px-4 pt-2': state.isMobileDevice},
            {'px-6': !state.isMobileDevice},
        )}>
            {sortedPractices.map((practice) => (
                <div key={practice.id}>
                    <PracticeCard
                        practice={practice}
                        isSelected={practice.id === state.selectedPractice?.id}
                        isMobileDevice={state.isMobileDevice}
                        userPickedLocation={state.userPickedLocation}
                        onClick={selectPractice}
                    />
                </div>
            ))}
        </div>
    )
}

export default PracticesList;